import { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import {
  changeLanguageEnglish,
  changeLanguagePersian,
} from "components/language";
import "assets/styles/components/navbar.scss";

function TopHeader() {
  const [locale, setLocale] = useState(true);
  const { t } = useTranslation();
  const linkItem = [
    {
      icon: "icon-linkdin icon-linkdin-sm",
      link: "https://www.linkedin.com/company/coinnikmarket ",
    },
    {
      icon: "icon-instagram icon-instagram-sm",
      link: "https://www.instagram.com/coinnikmarket/ ",
    },
    {
      icon: "icon-twitter icon-twitter-sm",
      link: "https://twitter.com/coinnikmarket",
    },
    { icon: "icon-mail icon-mail-sm", link: "mailito: info@coinnik.market" },
  ];
  return (
    <div className="top-header top-header-height">
      <Container>
        <Row className="d-flex justify-content-between">
          <Col xl="9">
            <div className="d-flex ">
              <span className="text-light box box-sm-dark-blue px-3 ms-3">
                {t("Zero fee!")}
              </span>
              <span className="text-light typed-out">
                {t("Occasion of the unveiling of the application")}
              </span>
            </div>
          </Col>
          <Col
            xl="2"
            className="d-flex justify-content-between align-items-center"
          >
            {linkItem.map((item) => (
              <>
                <div />
                <div />
                <Links icon={item.icon} link={item.link} />
              </>
            ))}
            {/* <Row className="d-flex justify-content-between ">
              <Col
                xs="6"
                className="d-flex justify-content-between align-items-center"
              >
                <i className="icon-language" />
                <Link
                  to="#"
                  onClick={() => {
                    changeLanguagePersian("fa");
                  }}
                  className={locale ? "text-light" : "text-secondary-one-light"}
                >
                  {t("Persian")}
                </Link>
                <Link
                  to="#"
                  onClick={() => {
                    changeLanguageEnglish("en");
                    setLocale((value) => !value);
                  }}
                  className={locale ? "text-secondary-one-light" : "text-light"}
                >
                  {t("English")}
                </Link>
              </Col>
              <Col xs="1" className="Vertical-line"></Col>
              <Col
                xs="4"
                className="d-flex justify-content-between align-items-center"
              >
                {linkItem.map((item) => (
                  <Links icon={item.icon} link={item.link} />
                ))}
              </Col>
            </Row> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const Links = ({ icon, link }: any) => (
  <a href={link} className="d-flex align-items-center">
    <i className={icon} />
  </a>
);
export default TopHeader;
